module.exports = __webpack_public_path__ + "static/media/reproductive_icon_blue.97cec91e.svg";